import { ModalWrapper } from '@/components/atoms/modal-wrapper'
import { css } from '@emotion/react'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface resetPasswordModalProps {
  isOpen: boolean
}

export const PasswordResetCompleteModal: React.FC<resetPasswordModalProps> = ({ isOpen }) => {
  const { t } = useTranslation()

  return (
    <ModalWrapper modalStyle={{ height: 'fit-content', width: 'fit-content' }} isOpen={isOpen} onClose={() => {}}>
      <h3 css={titleStyle}>{t('Password Updated')}</h3>

      <div css={noticeList}>
        <p>{t('Please close this window and log in again with a new password.')}</p>
      </div>
    </ModalWrapper>
  )
}

const titleStyle = css({
  textAlign: 'center',
  fontSize: '18px',
  fontWeight: 'bold',
  lineHeight: '1.5',
  marginBottom: '1.5rem',
})

const noticeList = css({
  textAlign: 'center',
  fontSize: '12px',
  lineHeight: '1.5',
  marginBottom: '1.5rem',
  P: {
    whiteSpace: 'pre-wrap',
  },
})
